import React, { useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import config from '../config';
import './Auth.css';

export default function Login() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const error = params.get('error');

  // Si aucune erreur et pas de redirection, rediriger vers home
  useEffect(() => {
    if (!error) {
      const timer = setTimeout(() => navigate('/'), 3000);
      return () => clearTimeout(timer);
    }
  }, [error, navigate]);

  const errorMessages = {
    no_code: 'La connexion Discord a echoue. Veuillez reessayer.',
    not_member: 'Vous n\'etes pas membre du serveur Discord Nexa RP. Rejoignez le serveur pour acceder a votre compte.',
    discord_error: 'Une erreur est survenue lors de la connexion Discord. Veuillez reessayer.',
    no_license: null, // Géré dans CharacterSelect
    no_character: null,
  };

  const msg = error ? errorMessages[error] : null;

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo.png" alt="Fleeca" className="auth-logo-img" onError={e => { e.target.style.display='none'; }} />
          <span className="auth-logo-text">Fleeca Bank</span>
        </div>

        {error && msg ? (
          <>
            <div className="auth-error-icon">
              <i className="fa-solid fa-circle-exclamation" />
            </div>
            <h2 className="auth-title">Acces refuse</h2>
            <p className="auth-desc error-text">{msg}</p>
            <Link to="/" className="btn-primary auth-btn">
              <i className="fa-solid fa-arrow-left" />
              Retour a l'accueil
            </Link>
          </>
        ) : (
          <>
            <div className="auth-loading-icon">
              <i className="fa-solid fa-building-columns spinner" />
            </div>
            <h2 className="auth-title">Connexion en cours...</h2>
            <p className="auth-desc">Vous allez etre redirige automatiquement.</p>
            <Link to="/" className="btn-secondary auth-btn">
              <i className="fa-solid fa-arrow-left" />
              Retour
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
